import React from 'react';

const ApiReference = () => {
  return (
    <section className="api-reference-container" style={{ backgroundColor: 'var(--black)', color: 'var(--text-light)', padding: '2rem', textAlign: 'center' }}>
      <h1 style={{ color: 'var(--gold)' }}>API Reference (Mock for MVP)</h1>
      <p>BankSystem's API is in early stages—secure, low-fee endpoints for wallet connects, transfers, and bots. Here's a simple mock overview:</p>
      <h2 style={{ color: 'var(--gold)' }}>Endpoint: /v1/wallet/connect</h2>
      <p>Method: POST</p>
      <p>Description: Connect via omnipass.eth SSO. Returns ENS subdomain (e.g., alice.xbsys.eth).</p>
      <p>Example Request: <code>{`{ "wallet": "0x...abc" }`}</code></p>
      <p>Example Response: <code>{`{ "id": "alice.xbsys.eth", "status": "connected" }`}</code></p>
      <h2 style={{ color: 'var(--gold)' }}>Endpoint: /v1/transfers/send</h2>
      <p>Method: POST</p>
      <p>Description: Send stablecoins with 0.05% fee. Use RWAs or AI bots for auto.</p>
      <p>Example Request: <code>{`{ "to": "bob.web3pay.eth", "amount": 100 }`}</code></p>
      <p>Example Response: <code>{`{ "txId": "0x...def", "fee": 0.05 }`}</code></p>
      <p>Fees to web3reg.eth. Full details post-MVP—integrate with Ethereum/Sepolia for now.</p>
    </section>
  );
};

export default ApiReference;
